<template>
    <v-container fluid class="pa-0">
    <!-- Formulaire -->
    <v-card fluid class="ma-2 pa-3 elevation-0 rounded-xxl micorise-v-card">
        <v-card-title >
            Fiche de santé / Traitement
            <v-spacer></v-spacer>
            <v-chip outlined color="secondary" v-if="item.hea_updated_at">
                <v-icon left>mdi-information-outline</v-icon>Modification: {{ $date(item.hea_updated_at).format('DD MMMM YYYY') }}
            </v-chip>
        </v-card-title>
        <v-form ref="form" v-model="validForm" lazy-validation>
        
        <!-- Type et Date -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-select outlined dense class="rounded-lg" :items="this.typeListByGroup['HEA']" item-text="typ_name" item-value="typ_id" v-model="item.hea_typ_id" label="Type d'intervention" single-line ></v-select>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
                <v-text-field :rules="requiredRules" outlined dense class="rounded-lg" label="Date de traitement" v-model="item.hea_treatment_date" type="date"></v-text-field>
            </v-col>
        </v-row>

        <!-- Produit -->
        <v-row no-gutters>
            <v-col cols="12" md="8" class="pr-2">
                <v-text-field :rules="requiredRules" outlined dense class="rounded-lg" label="Produit" v-model="item.hea_product" maxlength="150"></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="pl-2">
                <v-text-field outlined dense class="rounded-lg" label="ID Produit" v-model="item.hea_product_id" maxlength="100"></v-text-field>
            </v-col>
        </v-row>

        <!-- Dose et Unité -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-text-field outlined dense class="rounded-lg" label="Dose" v-model="item.hea_dose" type="number" step="0.0001"></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
                <v-select outlined dense class="rounded-lg" :items="this.typeListByGroup['HED']" item-text="typ_name" item-value="typ_id" v-model="item.hea_typ_id_dose" label="Unité de dose" single-line ></v-select>
            </v-col>
        </v-row>

        <!-- Voie administration et Délai d'attente -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-select outlined dense class="rounded-lg" :items="this.typeListByGroup['HAD']" item-text="typ_name" item-value="typ_id" v-model="item.hea_typ_id_way" label="Voie d'administration" single-line ></v-select>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
                <v-text-field outlined dense class="rounded-lg" label="Délai d'attente (jours)" v-model="item.hea_waiting_period" type="number"></v-text-field>
            </v-col>
        </v-row>

        <!-- Libellé -->
        <v-row no-gutters>
            <v-col cols="12">
                <v-text-field :rules="requiredRules" outlined dense class="rounded-lg" label="Libellé" v-model="item.hea_label" maxlength="100"></v-text-field>
            </v-col>
        </v-row>

        <!-- Prescripteur et Intervenant -->
        <v-row no-gutters>
            <v-col cols="12" md="6" class="pr-2">
                <v-text-field outlined dense class="rounded-lg" label="Prescripteur" v-model="item.hea_order" maxlength="50"></v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pl-2">
                <AutocompleteMulti 
                    :title="'Intervenant'" :ressource="'users'"
                    :listObject.sync="item.hea_usr_id" :listParent.sync="autoCompleteSource.userList"
                    :fields="{ 
                        index: 'id', text:'middleName', autofocus: true, dense: true,
                        search:'usr_middleName', multiSelect:false, prefetch: true, params:'' 
                    }"/>
            </v-col>
        </v-row>

        <!-- Champs personnalisés -->
        <v-row no-gutters>
            <v-col cols="12">
                <v-textarea outlined dense class="rounded-lg" label="Observations" v-model="item.hea_customfields.observation" rows="2"></v-textarea>
            </v-col>
        </v-row>

        </v-form>
        <v-card-actions>
            <v-btn class="rounded-xl" large color="red" v-if="item.hea_id" @click="deleteItem(item)"><v-icon title="Supprimer">mdi-delete</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-btn class="rounded-xl" large color="success" :loading="loading.fetchData" @click.native="saveItem()" :disabled="(loading.fetchData || !validForm)">Enregistrer</v-btn>
            <v-btn class="rounded-xl" large color="primary" :to="{ name: 'livestocks-healthrecords-list' }">Retour 2</v-btn>
        </v-card-actions>
    </v-card>
    </v-container>
</template>
    
<script>
import { mapState, mapWritableState, mapActions } from 'pinia'
import { useHealthrecordStore } from '@/stores/healthrecord'

import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'

export default {
    name: 'healthrecords-edit',
    props: ['livestock', 'switchTab', 'itemId'],
    components: { AutocompleteMulti },
    computed: {
        ...mapWritableState(useHealthrecordStore, {item: 'item' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
    },
    watch: { },
    data: function () {
        return {
            loading: { fetchData: true },
            validForm: true,
            requiredRules: [ v => !!v || 'Le champ doit être renseigné' ],
            autoCompleteSource: { userList: [] },
        }
    },
    async mounted () {
        const heaId = (this.itemId) ? this.itemId : this.$route.params.hea_id
        if (heaId && parseInt(heaId) > 0) {
            await this.fetchItem(heaId)
        } else {
           this.initItem()
           this.item.hea_lst_id = (this.livestock.lst_id && this.livestock.lst_id) ? this.livestock.lst_id : null
           this.item.hea_treatment_date = this.$date().format('YYYY-MM-DD')
        }
        this.loading.fetchData = false
    },
    methods: {
        ...mapActions(useHealthrecordStore, {fetchItem: 'fetchItem', updateItem: 'updateItem', storeItem: 'storeItem', deleteItem: 'deleteItem', initItem: 'RESET_ITEM'}),
        async saveItem () {
            await this.$refs.form.validate()
            if( this.validForm && !this.livestock ){
                // Enregistrement du formulaire
                this.loading.fetchData = true
                if( parseInt( this.$route.params.hea_id ) > 0 ){
                    await this.updateItem()
                } else {
                    await this.storeItem()
                }
                this.$router.push({ path: '/healthrecords' })
            } else if(this.validForm && this.livestock && this.livestock.lst_id){
                if( parseInt( this.$route.params.hea_id ) > 0 ){
                    await this.updateItem()
                } else {
                    await this.storeItem()
                }
                this.switchTab('1')
            }
        },
    }
}
</script>